// removed by extract-text-webpack-plugin
module.exports = {"Form":"Auth__Form__27pML","btn":"Auth__btn__2WoP5"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Auth/Auth.css
// module id = 144
// module chunks = 3